
<template>
  <div class="screen-container">
    <div
      class="box1"
      style="
        position: fixed;
        font-weight: bold;
        font-size: 1.25rem;
        width: 6.25rem;
        top: 0.9375rem;
        cursor: pointer;
        opacity: 0.6;
        border: 1px solid;
        border-radius: 10px;
        background: none;
      "
      @click="$router.back(-1)"
    >
      返回
    </div>
    <header class="screen-header">
      <div class="title">盐城CNC产能共享平台</div>
      <div class="desc">上云企业管理驾驶舱</div>
    </header>
    <div class="screen-body">
      <section class="screen-left">
        <div id="left-top">
          <cmp-left-top></cmp-left-top>
        </div>
        <div id="left-middle">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>APP数据趋势图</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <cmp-left-middle></cmp-left-middle>
            </div>
          </div>
        </div>
        <div id="left-bottom">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>模块使用情况</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <cmp-left-bottom></cmp-left-bottom>
            </div>
          </div>
        </div>
      </section>
      <section class="screen-middle">
        <div id="middle-top" style="height: 14%">
          <div
            style="height: 100%; display: flex; justify-content: space-between"
          >
            <div v-for="(item, index) in downApp" :key="index">
              <div>{{ item.name }}</div>
              <div
                class="bg2"
                style="height: 63px; display: flex; margin-top: 0.625rem"
              >
                <div
                  class="box1"
                  style="font-weight: bold; font-size: 1.25rem"
                  v-for="item1 in item.value"
                  :key="item1"
                >
                  {{ item1 }}
                </div>
                <div
                  style="
                    margin-left: 0.3125rem;
                    font-size: 1rem;
                    line-height: 4.4rem;
                    font-family: TXZT;
                    color: #75e6fe;
                  "
                >
                  {{ item.unit }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 50%;margin-top:-20px" id="middle-top2">
          <el-carousel :interval="4000" type="card" height="520px" >
            <el-carousel-item v-for="(item, index) in banner" :key="index">
              <el-image :src="item" style="height: 510px"></el-image>
              <!-- <h3>{{ index }}</h3> -->
            </el-carousel-item>
          </el-carousel>
        </div>
        <div id="middle-bottom" style="height: 23%">
          <div>
            <div
              class="gaizi"
              style="
                text-align: center;
                color: #00edff;
                font-size: 1.25rem;
                height: 2.5rem;
                line-height: 2.5rem;
              "
            >
              优秀企业 TOP5
            </div>
            <table
              style="text-align: center; width: 100%"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <thead>
                <tr style="background-color: #054468">
                  <td>排名</td>
                  <td>开机率</td>
                  <td>活跃率</td>
                  <td>数据量</td>
                  <td>联网率</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableData" :key="index">
                  <td v-if="index==0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3.492 8.065L4.778 19h14.444l1.286-10.935-4.01 2.673L12 4.441l-4.498 6.297-4.01-2.673zM2.801 5.2L7 8l4.186-5.86a1 1 0 0 1 1.628 0L17 8l4.2-2.8a1 1 0 0 1 1.547.95l-1.643 13.967a1 1 0 0 1-.993.883H3.889a1 1 0 0 1-.993-.883L1.253 6.149A1 1 0 0 1 2.8 5.2zM12 15a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="rgba(255,215,0,1)"/></svg></td>
                  <td v-else-if="index==1"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3.492 8.065L4.778 19h14.444l1.286-10.935-4.01 2.673L12 4.441l-4.498 6.297-4.01-2.673zM2.801 5.2L7 8l4.186-5.86a1 1 0 0 1 1.628 0L17 8l4.2-2.8a1 1 0 0 1 1.547.95l-1.643 13.967a1 1 0 0 1-.993.883H3.889a1 1 0 0 1-.993-.883L1.253 6.149A1 1 0 0 1 2.8 5.2zM12 15a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="rgba(192,192,192,1)"/></svg></td>
                  <td v-else-if="index==2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3.492 8.065L4.778 19h14.444l1.286-10.935-4.01 2.673L12 4.441l-4.498 6.297-4.01-2.673zM2.801 5.2L7 8l4.186-5.86a1 1 0 0 1 1.628 0L17 8l4.2-2.8a1 1 0 0 1 1.547.95l-1.643 13.967a1 1 0 0 1-.993.883H3.889a1 1 0 0 1-.993-.883L1.253 6.149A1 1 0 0 1 2.8 5.2zM12 15a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="rgba(191,173,111,1)"/></svg></td>
                  <td v-else>NO.{{ index + 1 }}</td>
                  <td>{{ item.boot }}</td>
                  <td>{{ item.active }}</td>
                  <td>{{ item.service }}</td>
                  <td>{{ item.click }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section class="screen-right">
        <div id="right-top">
          <cmp-right-top></cmp-right-top>
        </div>
        <div id="right-middle">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div>设备开机率</div>
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <cmp-right-middle></cmp-right-middle>
            </div>
          </div>
        </div>
        <div id="right-bottom">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <img src="/static/img/jt.png" />
                <div
                  style="
                    color: #00edff;
                    margin-left: 0.625rem;
                    font-size: 1.25rem;
                  "
                >
                  产业开机率
                </div>
                <span
                  style="
                    color: #0087f9;
                    font-size: 0.875rem;
                    align-self: end;
                    margin-left: 0.625rem;
                  "
                  >当前月</span
                >
              </div>
              <div class="box-line-1"></div>
              <div class="box-line-2"></div>
              <div class="box-line-3"></div>
              <div class="box-line-4"></div>
            </div>
            <div class="box-body">
              <cmp-right-bottom></cmp-right-bottom>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import cmpLeftTop from "@/components/cmp-left-top.vue";
import cmpLeftMiddle from "@/components/cmp-left-middle.vue";
import cmpLeftBottom from "@/components/cmp-left-bottom.vue";
import cmpRightTop from "@/components/cmp-right-top.vue";
import cmpRightMiddle from "@/components/cmp-right-middle.vue";
import cmpRightBottom from "@/components/cmp-right-bottom.vue";

export default {
  components: {
    cmpLeftTop,
    cmpLeftMiddle,
    cmpLeftBottom,
    cmpRightTop,
    cmpRightMiddle,
    cmpRightBottom,
  },
  data() {
    return {
      downApp: [],
      banner: [],
      tableData: [],
    };
  },
  mounted() {},
  computed: {},
  created() {
    this.getBannerData();
    this.getTableData();
  },
  methods: {
    async getBannerData() {
      const { data: ret } = await axios.get("/middle-top");
      this.banner = ret.banner;
      this.downApp = ret.data;
    },

    async getTableData() {
      const { data: ret } = await axios.get("/middle-bottom");
      this.tableData = ret.data;
    },
  },
};
</script>
<style>
.el-carousel__mask {
  background: none !important;
}
.el-image__inner {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style lang="less" scoped>
.gaizi {
  background: url(/static/img/gaizi@3x.png);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 120% 2.925rem;
}

.bg2 {
  background: url(/static/img/gx@3x.png);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 11.75rem 2.25rem;
}

.box1 {
  width: 2.1875rem;
  height: 2.6875rem;
  background: url("/static/img/szb@3x.png");
  font-family: "TXZT";
  display: flex;
  align-items: center;
  justify-content: center;
}

#middle-bottom {
  table {
    color: #abb8c0;

    td {
      padding:5px 7px;
    }

    thead {
      td {
        div {
          padding: 0.125rem;
        }
      }
    }

    tbody {
      td {
        font-size: 0.875rem;
      }
    }
  }
}

#middle-top {
  width: 100%;
  height: 100%;
}

#middle-top2 {
  width: 85%;
  margin: 0 auto;
  background: url("/static/img/banner@3x.png");
  background-repeat: no-repeat;
  -o-background-size: cover;
  background-position: 57% 35%;
  background-size: 158%;
}

::v-deep .el-carousel {
  height: 100%;
  overflow: hidden;
  .el-carousel__item {
    display: flex !important;
    // align-items: center;
    justify-content: center;
  }
  // .el-carousel__container {
  //   height: 100% !important;
  //   width: 85%;
  //   overflow: hidden;
  //   margin: 0 auto;
  // }

  // .el-carousel__mask {
  //   display: none;
  // }

  // .el-image__inner {
  //   width: 12.8rem;
  // }
}

.box {
  display: flex;
  flex-direction: column;
  height: 100%;

  .box-head {
    position: relative;

    .box-title {
      display: flex;
      align-items: center;
      padding: 10px 7px;
      border-bottom: 1px solid #0087f9;

      div {
        color: #00edff;
        margin-left: 0.625rem;
        font-size: 1.25rem;
      }
    }
  }

  .box-body {
    flex: 1;
    background-color: rgba(7, 65, 122, 0.2);
  }
}

.box-line-1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}

.box-line-2 {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}

.box-line-3 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}

.box-line-4 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}

// 全屏样式的定义
.fullscreen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  z-index: 100;
}

.resize {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}

.screen-container {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  background: url("/static/img/bg@3x.png");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  color: #fff;
  box-sizing: border-box;

  .screen-header {
    margin: 0 auto;
    width: 90%;
    height: 110px;
    background: url("/static/img/head@3x.png");
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;

    .title {
      color: #44c4ff;
      font-size: 2.2rem;
      text-align: center;
      padding-top: 0.9375rem;
      font-weight: bold;
      letter-spacing: 3px;
    }

    .desc {
      text-align: center;
      color: #44c4ff;
      font-size: 1.25rem;
      padding-top: 0.625rem;
    }
  }
}

.screen-body {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 10px;

  .screen-left {
    height: 100%;
    width: 27.6%;

    #left-top {
      height: 28%;
      position: relative;
    }

    #left-middle {
      height: 28%;
      margin-top: 10px;
      position: relative;
    }

    #left-bottom {
      height: 28%;
      margin-top: 10px;
      position: relative;
    }
  }

  .screen-middle {
    height: 100%;
    width: 41.5%;
    margin-left: 1.6%;
    margin-right: 1.6%;

    #middle-top {
      width: 100%;
      height: 56%;
      position: relative;
    }

    #middle-bottom {
      margin-top: 25px;
      width: 100%;
      height: 28%;
      position: relative;
    }
  }

  .screen-right {
    height: 100%;
    width: 27.6%;

    #right-top {
      height: 28%;
      position: relative;
    }

    #right-middle {
      height: 28%;
      margin-top: 10px;
      position: relative;
    }

    #right-bottom {
      height: 28%;
      margin-top: 10px;
      position: relative;
    }
  }
}
</style>
